import React, { useState}  from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
var FA = require('react-fontawesome')

const CopyLink = ctx => {
  function showLinkCopied() {
    setLinkCopied(true)
    setTimeout(()=>setLinkCopied(false),1500)
  }
  const [linkCopied, setLinkCopied] = useState(false)
  const { link } = ctx
  return <span>
    <span className={linkCopied ? "copied" : "not-copied" }>{link}</span> {" "}
    <CopyToClipboard text={link} onCopy={showLinkCopied}>
      <span className={linkCopied ? "link-copied" : "pointer"} title="Copy link"><FA name="copy" /></span>
    </CopyToClipboard>
    <style jsx>{`
      .copied {
        background-color: #dedede;
        padding:1px;
      }
      .link-copied::after {
        content: " Copied";
        }
      .not-copied {
        padding:1px;
      }
      .pointer {
         cursor: pointer;
      }
      `}</style>
  </span>
}

export default CopyLink
